var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHitsReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.93948 0C6.93532 0 6.12129 0.814028 6.12129 1.81818V2.72727H4.30311V4.54545C4.30311 5.04753 4.71013 5.45455 5.2122 5.45455H12.4849C12.987 5.45455 13.394 5.04753 13.394 4.54545V2.72727H11.5758V1.81818C11.5758 0.814028 10.7618 0 9.75766 0H7.93948ZM7.93948 2.72727C7.93948 2.2252 8.34649 1.81818 8.84857 1.81818C9.35064 1.81818 9.75766 2.2252 9.75766 2.72727C9.75766 3.22935 9.35064 3.63636 8.84857 3.63636C8.34649 3.63636 7.93948 3.22935 7.93948 2.72727Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666748 3.63636H3.39402V4.54545C3.39402 5.54961 4.20805 6.36364 5.2122 6.36364H12.4849C13.4891 6.36364 14.3031 5.54961 14.3031 4.54545V3.63636H17.0304V20H0.666748V3.63636ZM6.22233 9.20139L4.83344 11.1111L8.47927 11.9852L9.0001 9.89583L9.52094 11.9852L13.1668 11.1111L11.7779 9.20139L9.0001 8.33333L6.22233 9.20139ZM8.47925 12.8472L4.83342 11.4583L8.82647 16.6667L8.47925 12.8472ZM13.1667 11.4583L9.52092 12.8472L9.17369 16.6667L13.1667 11.4583Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHitsReport);
export default __webpack_public_path__ + "static/media/HitsReport.254a6d34efc54dd0391f815df5ba9aba.svg";
export { ForwardRef as ReactComponent };